<template>
  <div>
    <div class="o-container o-container--full u-pad-top--4 u-mrgn-bottom--4">
      <div class="u-txt--medium u-mrgn-bottom--3">{{ title }}</div>
      <div class="u-txt--base u-line-height--20"><EllipsisText :line-num="7" :message="pageDescription" /></div>
    </div>

    <div><ProductList :mutual-fund-type="type" /></div>

    <div><OtherLinkFooter :other-links="otherLinks" /></div>
  </div>
</template>

<script>
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';
import ProductList from 'shared/components/mweb/ProductList';
import OtherLinkFooter from 'shared/components/mweb/OtherLinkFooter';

export default {
  name: 'TypeDetailMobile',
  components: {
    OtherLinkFooter,
    ProductList,
    EllipsisText,
  },
  props: {
    otherLinks: {
      type: Array,
      default: () => [],
    },
    pageDescription: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
